<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Customers</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="6">
            <v-btn color="primary" small to="/new-customer">
              <v-icon left dark>mdi-plus</v-icon>New Customer
            </v-btn>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="6">
            <v-btn color="accent" class="float-right" text @click="customersDialog = true">
              <v-icon left>mdi-upload</v-icon>Import Customers
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
            hide-details></v-text-field>
        </v-row>

        <v-row class="subtitle-2 text--primary">
          <v-col cols="12" sm="12" md="12">
            <download-excel :data="customers" :fields="fields" name="customers">
              <v-icon color="green">mdi-file-excel</v-icon>
            </download-excel>
            <!-- start of table -->
            <v-data-table :items-per-page="pageItems" :headers="headers" :items="customers" :search="search"
              :mobile-breakpoint="zeroValue">
              <!-- name template -->
              <template v-slot:item.Name="{ item }">
                <v-btn color="accent" text :to="`/statement/customer/${item.id}`">
                  {{ item.Name }}
                  <v-icon right>mdi-eye</v-icon>
                </v-btn>
              </template>
              <!-- end -->

              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn color="editIcon" text :to="`/customer/${item.id}`" icon>
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <!-- end -->

              <!-- consignment template -->
              <template v-slot:item.isConsignmentCustomer="{ item }">
                <span style="color: #FF5733" v-if="item.isConsignmentCustomer == 1">Yes</span>
              </template>
              <!-- end -->

              <!-- action template -->
              <template v-slot:item.openingBalances="{ item }">
                <v-btn color="accent" text :to="`/customer/balances/${item.id}`">
                  <v-icon left>mdi-eye</v-icon>Opening Balances
                </v-btn>
              </template>
              <!-- end -->

              <!-- disable template -->
              <template v-slot:item.disable="{ item }">
                <v-btn color="red" @click="openDeleteModal(item)" text><v-icon left>mdi-close</v-icon> Disable Customer
                </v-btn>
              </template>
              <!-- end -->

            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>

        <v-row>
          <!-- customers dialog -->
          <v-dialog v-model="customersDialog" max-width="650px">
            <v-card>
              <v-toolbar dense color="primary" dark>
                <v-toolbar-title>Import Customers</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="customersDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" xs="12" md="12" class="mt-4">
                      <v-autocomplete autocomplete="off" hide-details dense outlined v-model="storeId" :items="stores"
                        label="Shop / Branch" item-text="Name" item-value="id"></v-autocomplete>
                    </v-col>

                    <v-col xs="12" sm="12" md="12" cols="12">
                      <v-file-input name="productExcelFile" v-model="excelFile" label="Browse Excel Sheet" outlined
                        dense></v-file-input>
                    </v-col>

                    <v-col xs="12" sm="12" md="12" cols="12">
                      <DatePicker @date="setDate" :myDate="date" :title="`Date`"></DatePicker>
                    </v-col>

                    <v-col cols="12">
                      <v-btn color="accent" @click="uploadExcel" :loading="loader">
                        <v-icon left>mdi-upload</v-icon>Upload
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end of modal-->

          <v-dialog v-model="deleteDialog" max-width="750px">
            <v-card>
              <v-toolbar dense color="secondary" flat>
                <v-toolbar-title> Delete / Disable Customer</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="deleteDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-container fluid>
                  <v-row class="text--primary subtitle-2">
                    <v-col cols="12">
                      Are you sure you want to disable this customer ?
                    </v-col>
                    <v-col cols="12">
                      <span style="font-size: 20px">{{ selectedItem.Name }}</span>
                    </v-col>

                    <v-col cols="12">
                      <v-btn color="red" dark :loading="loader" @click="deleteCustomer">Yes, Disable</v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end of modal-->

          <snackbar ref="snackbar"></snackbar>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    storeId: null,
    search: "",
    deleteDialog: false,
    selectedItem: {},
    customersDialog: false,
    loader: false,
    zeroValue: 0,
    pageItems: 100,
    date: null,
    headers: [
      { text: "Code", value: "DocNum" },
      { text: "Customer Name", value: "Name" },
      { text: "Phone", value: "PhoneNumber" },
      // { text: "Address", value: "Address" },
      { text: "Pin No", value: "PinNo" },
      // { text: "Credit Limit", value: "CreditLimit" },
      // { text: "Price List", value: "priceList.Name" },
      // { text: "Payment Terms", value: "paymentTerms.name" },
      { text: "Consignment", value: "isConsignmentCustomer" },
      { text: "Action", value: "action" },
      { text: "Disable", value: "disable" }
    ],
    fields: {
      Name: "Name",
      PhoneNumber: "PhoneNumber"
    },
    customers: [],
    excelFile: null
  }),
  methods: {
    setDate(myDate) {
      this.date = myDate;
    },
    openDeleteModal(data) {
      this.selectedItem = data;
      this.deleteDialog = true;
    },
    uploadExcel() {
      if (this.date == null) {
        this.$refs.snackbar.show("Please select date!", "red");
      } else {
        const data = new FormData();

        var storeId = 0;
        if (this.storeId != null) {
          storeId = this.storeId;
        }

        data.append("customersData", this.excelFile);
        data.append("date", this.date);
        data.append("store_id", storeId);
        //send request
        this.loader = true;
        const url = "/customer-import";
        const self = this;
        this.$store
          .dispatch("post", { url, data })
          .then(res => {
            if (res.ResultCode == 1200) {
              self.$refs.snackbar.show(
                "Customers imported successfully",
                "green"
              );
              self.loader = false;
              self.excelFile = null;
              self.customersDialog = false;
              self.getCustomers();
            } else {
              self.loader = false;
              self.$refs.snackbar.show(res.ResultDesc, "red");
            }
          })
          .catch(err => {
            self.loader = false;
            this.$refs.snackbar.show(err, "red");
          });
        // end
      }
    },
    getCustomers() {
      const self = this;
      this.$store
        .dispatch("get", `/customers`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.customers = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getStores() {
      var userId = localStorage.getItem("userId");
      const self = this;
      this.$store
        .dispatch("get", `/user-stores/${userId}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    deleteCustomer() {
      const url = `/customers/delete/${this.selectedItem.id}`;
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("remove", url)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            location.reload();
          } else {
            self.loader = false;
            self.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.loader = false;
          self.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getCustomers();
    this.getStores();
  }
};
</script>